import { FormattedMessage } from 'react-intl';
import React from 'react';

import { EventId } from '../constants';

export const checkLength = (value, length) => {
  if (value && value.length > length) {
    return <FormattedMessage id="formValidation_tooManyCharacters" values={{ numChars: length }} />;
  }
};

export const checkRequired = value => {
  if (!value || (typeof value === 'string' && !value.trim())) {
    return <FormattedMessage id="formValidation_required" />;
  }
};

export const checkUniqueNotCaseSensitive = (value, existingValues) => {
  if (existingValues.map(x => x.toLowerCase()).includes(value.toLowerCase())) {
    return <FormattedMessage id="formValidation_alreadyExists" values={{ value }} />;
  }
};

export const validateEvent = (value, _, props) => {
  if (value === EventId && props.decisionSplitObjects.find(x => x.id === EventId).fields == null) {
    return <FormattedMessage id="formValidation_validate_webinar" />;
  }
};



// WEBPACK FOOTER //
// ./src/Shared/Forms/FormValidation.js